import { render } from "./DashboardContent.vue?vue&type=template&id=cc74f38a"
const script = {}
script.render = render

export default script